<template>
  <div id="medicalAlertForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="medicalAlert.name" label="Name" :required="true" />
      <v-textarea
        outlined
        v-model="medicalAlert.description"
        label="Description"
        :rows="3"
      />

      <div class="d-flex">
        <v-radio-group v-model="medicalAlert.withOptions" row>
          <template v-slot:label>
            <div>Has Options</div>
          </template>
          <v-radio :value="true">
            <template v-slot:label>
              <div>Yes</div>
            </template>
          </v-radio>

          <v-radio :value="false">
            <template v-slot:label>
              <div>No</div>
            </template>
          </v-radio>
        </v-radio-group>
        <v-btn
          v-if="medicalAlert.withOptions"
          class="ml-4 my-auto"
          small
          @click="addOption"
          >Add Option</v-btn
        >
      </div>

      <div v-if="medicalAlert.withOptions">
          <div class="d-flex" v-for="(option, index) in options" :key="index">
            <v-text-field
              :rules="[rules.required]"
              dense
              outlined
              :label="`Option ${index + 1}`"
              v-model="option.name"
              placeholder="Enter option name"
            />
            <v-btn class="ml-2" @click="deleteOption(index)" icon>
              <v-icon> mdi-delete </v-icon>
            </v-btn>
          </div>
      </div>
      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>
    
<script>
import { getMedicalAlert } from "@/services/medicalAlert";
import { rules } from "@/store/util/rules.js";
import { mapActions } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      medicalAlert: {
        options: [],
        name: "",
        description: "",
        withOptions: false,
      },
      options: [],
      rules,
    };
  },
  created() {
    this.setInstance();
  },
  methods: {
    ...mapActions("medicalAlert", ["createMedicalAlert", "updateMedicalAlert"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      let medicalAlert = this.medicalAlert;
      if (medicalAlert.withOptions) {
        medicalAlert.options = this.options;
      } else {
        medicalAlert.options = null;
      }

      if (this.id) {
        this.updateMedicalAlert(medicalAlert)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("MedicalAlert was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating MedicalAlert, please try again later"
            );
          });
      } else {
        this.createMedicalAlert(medicalAlert)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Medical Alert was created successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating Medical Alert, please try again later"
            );
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.medicalAlert.id = this.id;
        getMedicalAlert(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.medicalAlert, property)
            ) {
              this.medicalAlert[property] = instance[property];
            }
          }

          this.options = this.medicalAlert.options;
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
    addOption() {
      this.options.push({ name: null });
    },
    deleteOption(index) {
      if (index > -1) {
        this.options.splice(index, 1);
      }
    },
  },
  components: {},
};
</script>
